import type { JSX } from 'react';

/**
 * @graph-stack styling-pattern-watch
 * @graph-domain Styling
 * @graph-business ページタイトル・説明・最終更新バナーを表示
 * @graph-connects none
 */
export function PageHeader(props: { lastUpdated: string; nextUpdate: string }): JSX.Element {
  return (
    <div className="page-header">
      <div>
        <h1 className="page-title">スタイリング選定可能型数ウォッチ</h1>
        <p className="page-desc">
          スタイリングコンソールに表示される
          <b>選定可能なpattern_id数</b>
          （item_skus由来）を、3時間おきにスナップショット集計してウォッチします。前回スナップショット比のデルタと閾値割れをハイライト表示します。
        </p>
      </div>
      <div className="update-banner">
        <span className="dot"></span>
        <span>
          最終更新: <b>{props.lastUpdated}</b>
        </span>
        <span className="next-update">| 次回更新: {props.nextUpdate}</span>
      </div>
    </div>
  );
}
